<template>
  <MultiLvSelectArea ref="MultiLvSelectArea" :data="sortSelectArea" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { mapState } from 'vuex'
import MultiLvSelectArea from './index'
import Pinyin from '@/utils/PinyinCode'
export default {
  name: 'AreaSelect',
  components: {
    MultiLvSelectArea
  },
  props: {
  },
  data() {
    return {
      sortSelectArea: [],
      selectAreaMap: {}
    }
  },
  computed: {
    ...mapState({
      selectArea: state => state.asyncRoute.selectArea,
    }),
  },
  watch: {
    selectArea: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this._sort()
      }
    },
  },
  mounted() {
  },
  methods: {
    pinyinSort(name) {
      // 提取拼音
      let pinyinArray = new Array()
      for (let bukn = 0; bukn < name.length; bukn++) {
        let o = new Object()
        let ken = Pinyin.getSpell(name[bukn], function (character, spell) {
          return spell[1]
        })
        o.name = name[bukn]
        o.pinyin = ken.split(',').join('')
        o.head = o.pinyin[0].toUpperCase()
        o = { ...o, ...this.selectAreaMap[o.name], id: this.selectAreaMap[o.name].value }
        pinyinArray.push(o)
      }

      let sortArr = pinyinArray.sort((a, b) => {
        if (a.head < b.head) {
          return -1
        }
        if (a.head > b.head) {
          return 1
        }
        return 0
      })

      let lastLetter = ''
      sortArr = sortArr.map(e => {
        if (e.head == lastLetter) {
          lastLetter = e.head
          return { ...e, head: '' }
        }
        lastLetter = e.head
        return e
      })
      return sortArr
      // debugger
      // 整理出首字母
      let map = {}
      pinyinArray.forEach((item, index) => {
        if (!map[item.pinyin[0].toUpperCase()]) {
          map[item.pinyin[0].toUpperCase()] = {
            title: item.pinyin[0].toUpperCase(),
            datas: []
          }
        }
        map[item.pinyin[0].toUpperCase()].datas.push({
          name: item.name,
          pinyin: item.pinyin,
          data: this.selectAreaMap[item.name]
        })
      })


      // 排序:
      let turn = new Array()
      let letters = 'ABCDEFGHIJKLNMOPQRSTUVWXYZ'.split('')
      for (let i = 0; i < letters.length; i++) {
        if (map[letters[i]]) {
          let obj = new Object()
          // 自己改改命名改成自己需要的
          obj.title = letters[i]
          obj.datas = map[letters[i]].datas
          turn.push(obj)
        }
      }

      // 不是字母的归类
      let other = { title: '#', datas: [] }
      let keyArr = Object.keys(map)
      let zz = /[a-z]/i
      keyArr.forEach(e => {
        if (!zz.test(e)) {
          other.datas = other.datas.concat(map[e].datas)
        }
      })

      turn.push(other)
      return turn
    },

    _sort() {
      this.selectAreaMap = this.selectArea.reduce((p, v) => (p[v.label] = v, p), {})
      let name = this.selectArea.map(e => e.label)
      let arr = this.pinyinSort(name)
      this.sortSelectArea = arr
    },
  },
}
</script>

<style scoped lang="scss">
</style>
